import { onUnmounted } from '@vue/runtime-core'

/*
 * @Author: 朱占伟
 * @LastEditors: 黄露
 * @description: 事件中转器
 * @Date: 2021-07-26 11:43:56
 * @LastEditTime: 2021-11-22 23:19:13
 */
class Bus {
  constructor() {
    // 收集订阅信息,调度中心
    this.list = {};
  }

  // 订阅
  $on(name, fn) {
    this.list[name] = this.list[name] || [];
    this.list[name].push(fn);
  }

  // 发布
  $emit(name, data = null) {
    if (this.list[name]) {
      this.list[name].forEach((fn) => {
        fn(data);
      });
    }
  }

  // 取消订阅
  $off(name, fn) {
    const callbackList = this.list[name]
    if (callbackList) {
      if (typeof fn === 'function') {
        callbackList.splice(callbackList.indexOf(fn) >>> 0, 1)
      } else {
        delete this.list[name];
      }
    }
  }
}

export function useEventBus (eventBus) {
  const cancellation = []

  onUnmounted(() => {
    cancellation.forEach(fn => fn())
    cancellation.length = 0
  })

  return { $on }

  function $on (eventName, callback) {
    eventBus.$on(eventName, callback)
    cancellation.push(() => {
      eventBus.$off(eventName, callback)
    })
  }
}

export function useGlobalEventBus () {
  return useEventBus(globalEventBus)
}

const globalEventBus = new Bus()

export default globalEventBus
